// Cashier Debit & Credit Transactions Actions
import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get debitCreditList from backend then update debitCreditList in vuex store ***** //
export const updateDebitCreditList = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload.id)) {
    throw new Error('Error')
  }

  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      start_date: payload.start_date,
      end_date: payload.end_date,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get(`cashier_debit_credit_index/${payload.id}`, {
      params: params
    })
    commit('updateDebitCreditList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching list data failed')
  }
}

// ***** Fetch debitCredit info ***** //
export const fetchDebitCreditInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`cashier_debit_credit_show/${payload}`)
    commit('setDebitCreditInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, creation failed')
  }
}
